import React from 'react';

import { Divider, TextField } from '@common-ui-library/atom';
import { useI18n } from '@common-ui-library/shared';
import { Dropdown } from '@common-ui-library/molecule';

import { ValueField } from '../../Utils/types';

const SiteFields = (isAddEntityOpen: boolean) => {
  const { t } = useI18n();
  const baseFieldProps = {
    fullWidth: true,
    variant: 'outlined',
    size: 'small',
    sx: {
      '& .MuiInputBase-root': {
        borderRadius: '8px',
        padding: '0px 12px',
        border: '1px solid rgba(33, 33, 33, 0.23)',
      },
      '& .MuiInputBase-input': {
        letterSpacing: '0.15px',
        lineHeight: '24px',
      },
      '& .MuiFormLabel-root': {
        letterSpacing: '0.1px',
        lineHeight: '157%',
        fontWeight: 500,
        fontFamily: 'Poppins',
      },
      gap: 1,
      color: '#212121',
    },
  };

  return [
    {
      label: t('labels.siteName'),
      component: TextField,
      componentProps: {
        ...baseFieldProps,
        name: 'name',
        fullWidth: true,
      },
      errorText: true,
      isRequired: true,
      fullGridWidth: true,
      eventHandlers: ['onChange', 'onBlur'],
    },
    {
      label: t('labels.timezone'),
      component: Dropdown,
      componentProps: {
        ...baseFieldProps,
        name: 'timezone',
        placeholder: t('placeholders.selectList'),
      },
      errorText: true,
      fullGridWidth: true,
      isRequired: true,
      valueField: ValueField.DEFAULT_VALUE,
      optionsKey: 'timezone_choices',
      eventHandlers: ['handleChangeOption'],
    },
    {
      label: '',
      component: Divider,
      componentProps: {
        flexItem: true,
        sx: {
          mb: 0,
          gap: 0,
          padding: 0,
        },
      },
      fullGridWidth: true,
    },
  ];
};

export default SiteFields;
